export default __webpack_public_path__ + "static/media/accessibility.e860c768.md";